var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCartIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.39 113.39",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 8.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.18,108.93H4.42l12.01-72.36h79.44l12.31,72.36ZM79.94,56.69V21.57c0-9.39-7.61-17.01-17.01-17.01h0c-9.39,0-17.01,7.61-17.01,17.01v35.13M54.43,6.84c-2.5-1.45-5.41-2.28-8.51-2.28h0c-9.39,0-17.01,7.61-17.01,17.01v15"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCartIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cart-icon.84f656f37b50ae8417c8183eafbca41a.svg";